import { TournamentEntity } from 'app/interfaces/entity';
import { useMemo } from 'react';
import { useCurrentUserTeamId } from './use-current-user-team-id';

export const useTeamPlace = (tournament: TournamentEntity) => {
  const { currentUserTeamId } = useCurrentUserTeamId(tournament);

  const teamPlace = useMemo(() => {
    const places = tournament?.results
      ?.filter((result) => result?.teamId === currentUserTeamId && result?.place)
      ?.map((result) => result.place ?? 0);

    return places?.length ? Math.min(...places) : 0;
  }, [tournament?.results, currentUserTeamId]);

  return { teamPlace };
};
